
import React from 'react';
import { Progress } from '@/components/ui/progress';

interface ProgressDisplayProps {
  progress: number;
  stage: string;
  pagesProcessed: number;
  totalPages: number;
}

const ProgressDisplay: React.FC<ProgressDisplayProps> = ({
  progress,
  stage,
  pagesProcessed,
  totalPages
}) => {
  // Ensure progress never exceeds 100%
  const safeProgress = Math.min(progress, 100);
  
  return (
    <div className="pt-2">
      <div className="flex justify-between items-center mb-3">
        <p className="font-medium text-lg">{stage}</p>
        <p className="text-sm text-muted-foreground">
          {pagesProcessed} of {totalPages || '?'} pages
        </p>
      </div>

      <div className="relative h-2.5 w-full">
        <Progress
          value={safeProgress}
          className="h-full"
          indicatorClassName="bg-gradient-to-r from-indigo-500 to-purple-600"
        />
        
        <div className="absolute -right-1 -top-1 bg-primary text-primary-foreground text-xs px-1.5 py-0.5 rounded-md transform translate-y-0 translate-x-0">
          {Math.round(safeProgress)}%
        </div>
      </div>
    </div>
  );
};

export default ProgressDisplay;
